<div class="vidstack-player-shell" [class.non-interactive]="!interactive()">
  <media-player
    class="vidstack-player"
    [src]="mediaSource()"
    [attr.title]="title() || null"
    [attr.poster]="poster() || null"
    [attr.view-type]="mediaType()"
    stream-type="on-demand"
    [attr.preload]="preload()"
    [attr.muted]="muted() ? '' : null"
    [attr.playsinline]="playsInline() ? '' : null"
    [attr.controls]="interactive() ? '' : null"
    [attr.aria-label]="title() || null"
  >
    <media-provider></media-provider>

    @if (interactive()) {
      @if (mediaType() === "video") {
        <media-video-layout></media-video-layout>
      } @else {
        <media-audio-layout></media-audio-layout>
      }
    }
  </media-player>
</div>
